import { computed } from "vue";

import type { SolvariEnv } from "@solvari/utils";

import { getAbTestFeature } from "@solvari/ab-testing";
import { getEnv } from "@solvari/utils";

import type { ProjectsMenuConfig } from "./projectsMenuConfig";

import { getProjectsMenuConfig } from "./projectsMenuConfig";

type LocaleCode = SolvariEnv["config"]["localeCode"];

type LocaleConfigOverride = Partial<Record<LocaleCode, ProjectsMenuConfig>>;

function useNavigation() {
  const navigationEnabledFeature = getAbTestFeature<boolean>(
    "main-site-products-navigation",
    false,
  );

  const navigationConfigFeature = getAbTestFeature<LocaleConfigOverride>(
    "main-site-products-navigation-config",
    null,
  );

  const navigationConfig = computed((): ProjectsMenuConfig | null => {
    const locale = getEnv().config.localeCode;
    const configOverride = navigationConfigFeature.value;

    if (configOverride?.[locale]) {
      return configOverride[locale];
    }

    return getProjectsMenuConfig(locale);
  });

  return {
    isNavigationEnabled: navigationEnabledFeature,
    navigationConfig,
  };
}

export { useNavigation };
